import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchAllOfferCards,
  setOffersSuccess,
  offerCardsSelector,
  fetchAllOffers,
} from '../../cmsSlice';
import CmsOfferCardsTable from './Offer-Cards-Table';
import {
  OFFER_VIEW,
  STATUS,
  OFFER_CARD_CREATE,
  OFFER_CARDS_FILTER,
  OFFER_CARDS_TYPE,
  OFFER_CARD_VIEW,
} from '../../../../constants/OfferConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_CMS_OFFERS,
} from '../../../../constants/RoleConsts';
import SearchBar from '../../../../shared/search-bar/Search-Bar';
import LinearProgressBar from '../../../../shared/progress-bar/Progress';
import ActivationPopupModel from '../../../../shared/activation-popup/Activation-Popup';
import {
  activateOfferCardDetail,
  deactivateOfferCardDetail,
  deleteOfferCardDetail,
  deleteSelectedItems,
  updateSelectedItemsStatus,
} from '../../../../utils/ServicesAPIUtils';
import { notificationManager } from '../../../../utils/NotificationUtils';
import DeletePopupModel from '../../../../shared/delete-popup/Delete-Popup';
import WarningPopup from '../../../../shared/warning-popup/Warning-Popup';
import useOutsideAlerter from '../../../../custom-hooks/useOutsideAlerter';
import { createDataSortMapping } from '../../../../utils/PropertyAPIUtils';
import MultipleDeleteConfirmationPopup from '../../../../shared/MultiActionPopUp/MultiDeleteConfirmationPopup';
import {
  ResetFilterList,
  getCheckedIds,
  updateCheckedStatus,
  updateSelectedModule,
} from '../../../../utils/formUtils';
import { generateConfirmationMessage } from '../../../../utils/formUtils';
import MultipleSelectionAlert from '../../../../shared/MultiActionPopUp/MultipleSelectionAlert';
import { decryptLocalStorage } from '../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../utils/loaderSlice';

const OfferCardsList = (props) => {
  const {
    onDrawerToggle,
    onViewToggle,
    hotelId,
    offerLoader,
    permissions,
    page,
    rowsPerPage,
    onsetRowsPerPage,
    onsetPage,
  } = props;
  const cmsOfferCards = useSelector(offerCardsSelector);
  const [offerCardList, setOfferCardList] = useState([]);
  const [filteredBaseList, setFilteredBaseList] = useState([]);
  const [filterDataList, setFilterDataList] = useState(OFFER_CARDS_FILTER);
  const [selectedValue, setSelectedValue] = useState({
    id: '',
    name: '',
    title: '',
    description: '',
    status: false,
    anchorEl: null,
    offer: {},
    modalType: '',
    type: '',
  });
  const dispatch = useDispatch();
  const wrapperRef = useRef(null);
  const [popUp, setPopUp] = useState(false);
  const [visible, setVisible] = useState(false);
  const [tempSearchText, setTempSearchText] = useState('');
  const [actionMenuList, setActionMenuList] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [showMultipleDeleteConfirmation, setShowMultipleDeleteConfirmation] = useState(false);
  const [actionName, setActionName] = useState(false);
  const [showBulkActiveDeactiveConfirmation, setShowBulkActiveDeactiveConfirmation] =
    useState(false);
  const [isActive, setIsActive] = useState(false);
  const checkedOfferCard = offerCardList?.filter((restaurant) => restaurant?.isChecked);
  const [showBulkKebabSelectionAlert, setShowBulkKebabSelectionAlert] = useState(false);
  const selectedOfferCardListLength = checkedOfferCard.length;
  const listOfOfferCardIds = checkedOfferCard.map((item) => item?.id);
  const [showBulkSearchAlert, setShowBulkSearchAlert] = useState(false);
  const isFilterApplied = useRef(false);
  const prevHotelIdRef = useRef(hotelId);

  useEffect(() => {
    const baseList = cmsOfferCards?.map((offerCard) => ({
      ...offerCard,
      isChecked: false,
    }));
    setOfferCardList(baseList);
    setFilteredBaseList(baseList);
    setTempSearchText('');
    resetFilterDataList();
  }, [cmsOfferCards]);

  const setSearchText = async (searchText) => {
    setTempSearchText(searchText);
    const checkedIdList = getCheckedIds(offerCardList, 'isChecked');
    const filteredRows = await filteredBaseList.filter((item) => {
      return item.offerCardName.toLowerCase().includes(searchText.toLowerCase());
    });
    const updatedCheckedList = updateCheckedStatus(filteredRows, checkedIdList);
    onsetPage(0);
    setOfferCardList(updatedCheckedList);
    if (searchText && (isAllSelected || selectedOfferCardListLength > 0)) {
      setShowBulkSearchAlert(true);
    } else if (!searchText) {
      setShowBulkSearchAlert(false);
      setOfferCardList(filteredBaseList?.length ? filteredBaseList : cmsOfferCards);
    }
  };

  useEffect(() => {
    updateSelectedModule(offerCardList, setActionMenuList, setIsAllSelected);
  }, [offerCardList]);

  const resetFilterDataList = () => {
    OFFER_CARDS_FILTER[1].subMenu = OFFER_CARDS_TYPE;
    OFFER_CARDS_FILTER[2].subMenu = STATUS;
    setFilterDataList(OFFER_CARDS_FILTER);
  };

  useEffect(() => {
    resetFilterDataList();
  }, []);

  useEffect(() => {
    if (offerLoader || offerCardList?.length === 0) return;
    const totalItems = offerCardList?.length;
    const maxPageIndex = Math.max(Math.ceil(totalItems / rowsPerPage) - 1, 0);
    if (page > maxPageIndex) {
      onsetPage(maxPageIndex);
    }
  }, [offerCardList?.length, rowsPerPage, page, onsetPage]);

  useEffect(() => {
    if (prevHotelIdRef?.current !== hotelId) {
      onsetPage(0);
    }
    prevHotelIdRef.current = hotelId;
  }, [hotelId]);

  const filteredRecords = (filters, field) => {
    if (field === 'all') {
      isFilterApplied.current = false;
      const filterList = [...filterDataList];
      const delaultFilter = filterList.map((data) => {
        let subMenuData = [];
        if (data.subMenu && data.subMenu.length > 0) {
          subMenuData = data.subMenu.map((subMenu) => {
            return { ...subMenu, selected: false };
          });
        }
        return { ...data, subMenu: subMenuData };
      });
      setFilterDataList(delaultFilter);
      onsetPage(0);
      setFilteredBaseList(cmsOfferCards);
      setOfferCardList(cmsOfferCards);
      return true;
    }

    isFilterApplied.current = true;
    const filterIdWithFields = filterDataList
      .filter((initialFilter) => initialFilter.subMenu.length > 0)
      .map((filterItem) => {
        const subMenuFiltersId = filterItem.subMenu
          .filter((fItem) => fItem.selected === true)
          .map((fItemId) => fItemId.id);
        if (subMenuFiltersId.length > 0) {
          return {
            id: subMenuFiltersId,
            field: filterItem.field,
          };
        } else return null;
      })
      .filter((item) => item !== null);
    const filteredRecords = cmsOfferCards.filter((offer) => {
      const doesFilterSatisfy = filterIdWithFields.map((filter) =>
        filter.id.includes(offer[filter.field]),
      );
      return !doesFilterSatisfy.includes(false);
    });
    onsetPage(0);
    setFilteredBaseList(filteredRecords);
    setOfferCardList(filteredRecords);
  };

  const onOpenDrawer = (event, type) => {
    if (selectedOfferCardListLength) {
      setOfferCardList(ResetFilterList);
    }
    event.stopPropagation();
    onDrawerToggle(type, true, selectedValue.offer);
    handleClose();
  };

  const handleClose = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
      warning: false,
      Offer: null,
      modalType: '',
      type: '',
    });
  };

  const onClickRowViewDetails = (offerItem, e, isClassDisabled) => {
    if (isClassDisabled) return onViewToggle(OFFER_VIEW, true, offerItem);
    if (e.target.className === 'MuiTableCell-root MuiTableCell-body') {
      onViewToggle(OFFER_CARD_VIEW, true, offerItem);
    }
  };

  const onViewDetails = () => {
    onViewToggle(OFFER_CARD_VIEW, true, selectedValue.offer);
  };

  const handleCellMenuClick = (event, offer) => {
    if (selectedOfferCardListLength > 1) {
      setShowBulkKebabSelectionAlert(true);
    } else {
      setSelectedValue({
        id: offer.id,
        name: offer.offerCardName,
        title: '',
        description: '',
        status: false,
        warning: false,
        anchorEl: event.currentTarget,
        offer,
        isLive: offer?.status === 'Live' || offer?.status === 'Scheduled',
        modalType: '',
        type: '',
      });
    }
  };

  const handleChangePage = (event, newPage) => {
    onsetPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onsetRowsPerPage(parseInt(event.target.value, 10));
    onsetPage(0);
  };

  const onActiveDeActiveOffer = (e, type) => {
    e.preventDefault();
    setSelectedValue((prev) => ({
      ...prev,
      name: `${prev.offer.offerCardName} ?`,
      title: `Are you sure you want to ${type}`,
      description: `You can reschedule it in Offer Card Edit page to ${
        type === 'deactivate' ? 'activate' : 'deactivate'
      } the offer card`,
      status: true,
      anchorEl: null,
      modalType: 'activeModal',
      type,
    }));
  };

  const onOkClick = async () => {
    resetFilterDataList();
    try {
      dispatch(stepUpLoaderCount());
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      const payload = { hotelId, id: selectedValue.id };
      selectedValue.type === 'deactivate'
        ? await deactivateOfferCardDetail(payload, language)
        : await activateOfferCardDetail(payload, language);
      dispatch(fetchAllOfferCards(hotelId));
      notificationManager(
        'success',
        `Offer card ${
          selectedValue.type === 'deactivate' ? 'deactivated' : 'activated'
        } successfully`,
      );
      handleClose();
    } catch (e) {
      if (e.graphQLErrors) notificationManager('danger', e.graphQLErrors[0].message);
      else notificationManager('danger', `Failed to ${selectedValue.type} offer card`);
    } finally {
      dispatch(stepDownLoaderCount());
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  const onDeleteOffer = async () => {
    resetFilterDataList();
    try {
      dispatch(stepUpLoaderCount());
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      const payload = { hotelId, id: selectedValue.id };
      await deleteOfferCardDetail(payload, language);
      dispatch(fetchAllOfferCards(hotelId));
      dispatch(fetchAllOffers(hotelId));
      notificationManager('success', `Offer card deleted successfully`);
      handleClose();
    } catch (e) {
      if (e.graphQLErrors) notificationManager('danger', e.graphQLErrors[0].message);
      else notificationManager('danger', `Failed to delete offer card`);
    } finally {
      dispatch(stepDownLoaderCount());
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  const onClickDeleteOffer = async () => {
    if (selectedValue.isLive) {
      setSelectedValue((prev) => ({
        ...prev,
        description: `This offer card is currently ${selectedValue.offer.status} and thus cannot be deleted. In order to delete this offer card, deactivate this offer and try again.`,
        status: false,
        warning: true,
        anchorEl: null,
        modalType: 'warningModal',
        type: 'Delete this ',
      }));
    } else {
      setSelectedValue((prev) => ({
        ...prev,
        title: 'Are you sure you want to delete',
        description: 'This action cannot be reversed',
        status: true,
        warning: false,
        anchorEl: null,
        modalType: 'deleteModal',
      }));
    }
  };

  const handleAction = (actionName) => {
    let selectedValue = offerCardList?.filter((offerCard) => offerCard?.isChecked);

    switch (actionName) {
      case 'Delete':
        if (selectedValue?.length > 0) {
          setShowMultipleDeleteConfirmation(true);
          setActionName('delete');
        }
        break;
      case 'Activate':
        if (selectedValue?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('activate');
          setIsActive(true);
        }
        break;
      case 'Deactivate':
        if (selectedValue?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('deactivate');
          setIsActive(false);
        }
        break;
      default:
        break;
    }
  };

  const onApiCallConfirmationNotification = generateConfirmationMessage(
    'Offer Card',
    listOfOfferCardIds?.length,
    isActive,
  );

  const handleMultipleStatusChange = async () => {
    handleClose();
    setActionMenuList([]);
    try {
      dispatch(stepUpLoaderCount());
      const filterApplied = tempSearchText.length > 0 || isFilterApplied?.current ? true : false;
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'OFFER_CARD';
      await updateSelectedItemsStatus(
        listOfOfferCardIds,
        hotelId,
        selectedLang,
        moduleName,
        '',
        isActive,
        filterApplied ? false : isAllSelected,
      );
      dispatch(fetchAllOfferCards(hotelId));
      notificationManager('success', onApiCallConfirmationNotification);
      setSelectedValue({
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        activate: false,
        brand: null,
      });
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors
          ? e.graphQLErrors[0].message
          : 'The status of the Offer Cards was not changed',
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }
    setIsAllSelected(false);
    setOfferCardList(ResetFilterList);
  };

  const deleteMultipleSelection = async () => {
    handleClose();
    try {
      dispatch(stepUpLoaderCount());
      const filterApplied = tempSearchText.length > 0 || isFilterApplied?.current ? true : false;
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'OFFER_CARD';
      await deleteSelectedItems(
        listOfOfferCardIds,
        hotelId,
        selectedLang,
        moduleName,
        '',
        filterApplied ? false : isAllSelected,
      );
      dispatch(fetchAllOfferCards(hotelId));
      notificationManager('success', 'Offer Cards deleted successfully');
      setSelectedValue({
        ...selectedValue,
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        brand: null,
      });
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : 'Failed to delete Offer Card',
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  useOutsideAlerter(wrapperRef, visible, setPopUp);

  const handleSelectAll = (event) => {
    let setSelectedOfferCardList = [];
    let actionListName = [];
    let actionName = '';
    const CheckedValue = event?.target?.checked;

    setIsAllSelected(CheckedValue);
    setSelectedOfferCardList = offerCardList?.map((offerCard) => {
      return {
        ...offerCard,
        isChecked: CheckedValue,
      };
    });
    setSelectedOfferCardList?.forEach((action) => {
      if (['Scheduled', 'Live'].includes(action?.status)) {
        actionName = 'Deactivate';
      } else if (['Inactive'].includes(action?.status)) {
        actionName = 'Activate';
      }
      if (!actionListName.includes(actionName) && actionName !== '') {
        actionListName.push(actionName);
      }
    });
    setOfferCardList([...setSelectedOfferCardList]);

    const sortActionMenuList = actionListName.sort((a, b) => {
      const order = { Activate: 1, Deactivate: 2, Delete: 3 };
      return order[a] - order[b];
    });

    setActionMenuList(sortActionMenuList);

    if (
      !event?.target?.checked &&
      !setSelectedOfferCardList?.some((offerCard) => offerCard?.isChecked)
    ) {
      setActionMenuList([]);
    }
  };

  const handleCheckboxChange = (id) => {
    let actionListName = [];
    let actionName = '';
    let actionList = [];
    let index = offerCardList?.findIndex((offerCard) => offerCard.id === id);
    if (!offerCardList[index]?.isChecked) {
      offerCardList[index] = {
        ...offerCardList[index],
        isChecked: true,
      };
    } else {
      offerCardList[index].isChecked = !offerCardList[index]?.isChecked;
    }
    setOfferCardList([...offerCardList]);

    actionList = offerCardList
      ?.filter((notification) => notification?.isChecked)
      .map((status) => status?.status);

    const checkedItems = offerCardList?.filter((discount) => discount?.isChecked);

    if (checkedItems?.length === 0) {
      setActionMenuList([]);
      setIsAllSelected(false);
      return;
    }

    actionList?.forEach((action) => {
      if (['Scheduled', 'Live'].includes(action)) {
        actionName = 'Deactivate';
      } else if (['Inactive'].includes(action)) {
        actionName = 'Activate';
      }
      if (!actionListName.includes(actionName) && actionName !== '') {
        actionListName.push(actionName);
      }
    });

    const isAllSelected = offerCardList?.every((offerCard) => offerCard?.isChecked);
    setIsAllSelected(isAllSelected);
    setActionMenuList(actionListName);
  };
  const handleBulkSearchAlertClose = () => {
    setShowBulkSearchAlert(false);
    setSearchText('');
    setOfferCardList(
      cmsOfferCards.map((res) => ({
        ...res,
        isChecked: false,
      })),
    );
  };

  return (
    <div className='mt-4 mb-4 group-list-container'>
      <SearchBar
        type={OFFER_CARD_CREATE}
        buttonName='Add Offer Card'
        setSearchText={setSearchText}
        onOpenDrawer={onOpenDrawer}
        filterList={filterDataList}
        displayAddOrEdit={
          permissions[RBAC_TYPE_CMS_OFFERS] === RBAC_PERMISSION_LEVEL_FULL_ACCESS ? 'show' : 'hide'
        }
        setFilterDataList={setFilterDataList}
        filteredRecoard={filteredRecords}
        visible={visible}
        setVisible={setVisible}
        popUp={popUp}
        setPopUp={setPopUp}
        placeHolder={offerCardList}
        setPlaceHolder={setOfferCardList}
        globalPlaceHolder={cmsOfferCards}
        setGlobalPlaceHolder={setOffersSuccess}
        dispatch={dispatch}
        mappingApi={createDataSortMapping}
        displayText='Offer Cards'
        module='OFFER_CARD'
        searchText={tempSearchText}
        setSearch={setTempSearchText}
        actionMenuItems={actionMenuList ?? []}
        handleAction={handleAction ?? false}
      />
      <div ref={wrapperRef} className='row mx-2 d-flex mt-4'>
        {offerLoader && (
          <div className='pt-4 col-md-12'>
            <LinearProgressBar />
          </div>
        )}
        <CmsOfferCardsTable
          page={page}
          rowsPerPage={rowsPerPage}
          onOpenDrawer={onOpenDrawer}
          onClickRowViewDetails={onClickRowViewDetails}
          onViewDetails={onViewDetails}
          selectedValue={selectedValue}
          handleClose={handleClose}
          handleCellMenuClick={handleCellMenuClick}
          offerList={offerCardList}
          setOfferList={setOfferCardList}
          permissions={permissions}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          onActiveDeActiveOffer={onActiveDeActiveOffer}
          onClickDeleteOffer={onClickDeleteOffer}
          setVisible={setVisible}
          setActionMenuList={setActionMenuList}
          actionMenuList={actionMenuList}
          handleSelectAll={handleSelectAll}
          handleCheckboxChange={handleCheckboxChange}
          isAllSelected={isAllSelected}
          setIsAllSelected={setIsAllSelected}
          selectedOfferCardListLength={selectedOfferCardListLength}
          cmsOfferCards={cmsOfferCards}
        />
      </div>
      {selectedValue.status && selectedValue.modalType === 'activeModal' && (
        <ActivationPopupModel
          activationPopUp={selectedValue}
          cancelButtonName='No'
          okButtonName='Yes'
          onOkClick={() => onOkClick()}
          onActivationPopupActionCancel={handleClose}
        />
      )}
      {selectedValue.status && selectedValue.modalType === 'deleteModal' && (
        <DeletePopupModel
          deletePopUp={selectedValue}
          onDelete={onDeleteOffer}
          onDeleteCancel={handleClose}
        />
      )}
      {selectedValue.id && selectedValue.warning && selectedValue.modalType === 'warningModal' && (
        <WarningPopup warningPopup={selectedValue} onWarningClose={handleClose} warn={true} />
      )}
      {showMultipleDeleteConfirmation && (
        <MultipleDeleteConfirmationPopup
          title={`Are you sure you want to ${actionName} this selection?`}
          subTitle={`A selection of ${selectedOfferCardListLength} ${
            selectedOfferCardListLength > 1 ? 'offer cards' : 'offer card'
          } will be ${actionName}d. This Action is irreversible.`}
          isOpen={showMultipleDeleteConfirmation}
          onClose={() => setShowMultipleDeleteConfirmation(false)}
          onConfirm={() => {
            deleteMultipleSelection();
          }}
          leftButtonName={'Cancel'}
          rightButtonName={'Delete'}
        />
      )}

      {showBulkActiveDeactiveConfirmation && (
        <MultipleDeleteConfirmationPopup
          title={`Are you sure you want to ${actionName} this selection?`}
          subTitle={`A selection of ${selectedOfferCardListLength}  ${
            selectedOfferCardListLength > 1 ? 'offer cards' : 'offer card'
          } will be ${actionName}d.`}
          isOpen={showBulkActiveDeactiveConfirmation}
          onClose={() => setShowBulkActiveDeactiveConfirmation(false)}
          onConfirm={() => {
            handleMultipleStatusChange();
          }}
          leftButtonName={'No'}
          rightButtonName={'Yes'}
        />
      )}
      {showBulkSearchAlert && (
        <MultipleSelectionAlert
          isOpen={showBulkSearchAlert}
          onClose={handleBulkSearchAlertClose}
          message="If you perform a search after making selections, the items you've selected will be lost."
          ButtonName='Cancel'
        />
      )}
      {showBulkKebabSelectionAlert && (
        <MultipleSelectionAlert
          isOpen={showBulkKebabSelectionAlert}
          onClose={() => setShowBulkKebabSelectionAlert(false)}
          message='Please select one item from the list that you want to edit.'
          centerButtonName='OK'
        />
      )}
    </div>
  );
};

export default OfferCardsList;
